import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import useEnterAdvancesFocus from '../../utils/useEnterAdvancesFocus';

export default function Layout() {
  useEnterAdvancesFocus();
  return (
    <div className="layout">
      <Sidebar />
      <div className="main-content">
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
